module.exports = __webpack_public_path__ + "media/icons/tire-5ad3134c.png";